import { WorkflowGraphDto } from "../../types/workflowDefinitionDto";
import { isPifDefinitionToken } from "./pifWorkflowKeys";
import { isBuilderEditableApproverSource } from "./workflowStageConfigJson";

export const WORKFLOW_SEED_ONLY_MESSAGES = {
  PIF:
    "The New Hire PIF is published from code by the PIF seed, so it opens read-only here. " +
    "Saving it in the Builder would replace its HR and Executive Director approvers.",
  UNSUPPORTED_APPROVER:
    "An approval step in this workflow takes its approver from a system setting, which the Builder " +
    "can't edit yet, so it opens read-only. Saving it here would replace that approver.",
} as const;

/**
 * Epic 80431 (Pooja Pujara, 2026-10-13): the PIF stays seed-only, so the Builder must not save it by
 * accident. Read-only, with the reason, when the graph is the PIF or holds an approver option the
 * Builder can't represent; null when the Builder may edit it.
 */
export const seedOnlyMessage = (graph: WorkflowGraphDto): string | null => {
  if (isPifDefinitionToken(graph.definition.token)) return WORKFLOW_SEED_ONLY_MESSAGES.PIF;

  const unsupported = graph.stages.some(
    (stage) => stage.stageType === "approval" && !isBuilderEditableApproverSource(stage.configJson),
  );
  return unsupported ? WORKFLOW_SEED_ONLY_MESSAGES.UNSUPPORTED_APPROVER : null;
};
